import React from 'react'
import { observer } from 'mobx-react'

import column from '../assets/colyoy.svg'
import bar from '../assets/bar.svg'
import stackedbar from '../assets/stackedavg.svg'
import stackedcolumn from '../assets/stackedcolumn.svg'
import oss from '../assets/oss.svg'
import derived from '../assets/derived.svg'
import lmx from '../assets/lmx.svg'
import npskpi from '../assets/kpinps.svg'
import pie from '../assets/pie.svg'
import doughnut from '../assets/donut.svg'
import npsExplainer from '../assets/npsexplainer.svg'
import correlationExplainer from '../assets/correlationexplainerslide.svg'

const QuestionSlidePreview = ({ dir = 'row', count = 1, wrap = false, slide, typeOverride = null }) => {
    const srcForChart = (chartType) => {
        switch (chartType) {
            case 'npsChart':
            case 'kpiChart':
                return npskpi
            case 'npsExplainer':
                return npsExplainer
            case 'standardColumn':
                return column
            case 'standardBar':
                return bar
            case 'stackedBar':
                return stackedbar
            case 'stackedColumn':
                return stackedcolumn
            case 'quadrantAnalysis':
                return derived
            case 'oss':
                return oss
            case 'lmx':
                return lmx
            case 'pie':
                return pie
            case 'doughnut':
                return doughnut
            case 'correlationExplainer':
                return correlationExplainer
            default:
                return null
        }
    }
    return (
        <div style={{ backgroundColor: '#EFF4F6', height: '100%' }}>
            <div style={{ height: 10, backgroundColor: '#0B243A', position: 'relative' }}>
                <img src="https://cdn.explori.com/images/logo_explori.png" alt="explori logo" style={{ height: 5, position: 'absolute', right: 2, top: 2 }} />
            </div>

            <div style={{ display: 'flex', flexDirection: dir, padding: 5, height: 'calc(100% - 10px)', gap: 2, flexWrap: wrap ? 'wrap' : 'nowrap' }}>
                {new Array(count).fill(0).map((_, i) => {
                    const question = slide?.question?.get(i)

                    return (
                        <div style={{ height: wrap ? '48%' : '100%', width: wrap ? '48%' : '100%', backgroundColor: 'white', padding: 5, display: 'flex', justifyContent: 'center', alignItems: 'center' }} key={i}>
                            {typeOverride ? (
                                <img src={srcForChart(typeOverride)} style={{ height: '100%', width: '100%' }} />
                            ) : (
                                <img src={srcForChart(question?.kpiType === 'OSS' ? 'oss' : question?.chart)} style={{ height: '100%', width: '100%' }} />
                            )}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default observer(QuestionSlidePreview)
